import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Row, Col } from 'react-flexbox-grid';

import ActionButton from 'components/ActionButton';
import { actions } from 'store/newDocumentStore';
import { getFormValues } from 'redux-form';

const BottomFormControls = ({ name, editId, dispatch, commitId, currentFormValues }) => (
  <Row middle="xs" center="xs" end="sm" style={{ marginBottom: '1rem' }}>
    <Col xs={12} sm={5} mdOffset={2} md={4} lgOffset={3} lg={3}>
      <Row>
        <Col xs={6}>
          <ActionButton
            localeId="toolbar.action.cancel"
            secondary
            onClick={e => dispatch(actions.discardCommit(name, editId, commitId))}
          />
        </Col>
        <Col xs={6}>
          <ActionButton
            localeId="toolbar.action.done"
            border
            secondary
            onClick={e => dispatch(actions.finishCommit(name, editId, commitId, currentFormValues))}
          />
        </Col>
      </Row>
    </Col>
  </Row>
);

BottomFormControls.propTypes = {
  name: PropTypes.string.isRequired,
  editId: PropTypes.string.isRequired,
  commitId: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
  currentFormValues: PropTypes.object,
};

const mapStateToProps = (state, ownProps) => {
  let currentFormValues = null;
  if (ownProps.name && state.form) {
    currentFormValues = getFormValues(ownProps.name)(state);
  }
  return { currentFormValues };
};

export default connect(mapStateToProps)(BottomFormControls);
